import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';
import * as artifactActions from '~/artifact/actions';
import * as MODEL from '~/constants/ModelConstants';
type ArtifactViewReferencesListItemProps = {
  actions: object;
  artifactState: object;
  isEditMode: boolean;
  link: object;
  linkIndex: number;
};
class ArtifactViewReferencesListItem extends React.Component<
  ArtifactViewReferencesListItemProps,
  {}
> {
  toggleEditArtifactLink = () => {
    this.props.actions.updateArtifactCurrentlyEditing({
      artifactLinkIndex: this.props.linkIndex,
    });
    this.props.actions.updateArtifactLinkBeforeEdits(this.props.linkIndex);
  };
  deleteArtifactLink = () => {
    this.props.actions.deleteArtifactLink(this.props.linkIndex);
  };
  render() {
    let link = this.props.link,
      linkIndex = this.props.linkIndex,
      isFirst = linkIndex === 0,
      filterNameMap = MODEL.artifactViewFilterNameMap,
      key = linkIndex,
      borderClasses = classNames({
        'border-color--white-dark': true,
        'bo-t--1': !isFirst,
        'bo--0': isFirst,
      }),
      urlClass = 'grid__item text--overflow pr 1-2 phone--no-overflow width--200',
      linkHtml = null,
      typeTextHtml = null;
    if (link.type === 'OTHER') {
      typeTextHtml = (
        <div className="grid__item col-1-2 phone--col-1-1" style={{wordBreak: 'break-word'}}>
          <div>{link.title}</div>
        </div>
      );
    } else if (link.type === 'FOUND_BY') {
      typeTextHtml = (
        <div className="grid__item col-1-2 phone--col-1-1" style={{wordBreak: 'break-word'}}>
          <div>{filterNameMap[link.type]}</div>
        </div>
      );
    } else {
      let titleText = link.title !== '' ? ' - ' + link.title : '';
      typeTextHtml = (
        <div className="grid__item col-1-2 phone--col-1-1" style={{wordBreak: 'break-word'}}>
          <div>
            {filterNameMap[link.type]}
            {titleText}
          </div>
        </div>
      );
    }
    if (link.type === 'FOUND_BY') {
      linkHtml = (
        <div className={urlClass}>
          <a href={link.url} className=" link--primary">
            {link.title}
          </a>
        </div>
      );
    } else {
      linkHtml = (
        <div className={urlClass}>
          <a href={link.url} className=" link--primary">
            {link.url}
          </a>
        </div>
      );
    }
    return (
      <div className={borderClasses} key={key}>
        <div className="grid grid--middle mv- pv--">
          {typeTextHtml}
          {linkHtml}
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    artifactState: state.artifactState,
    myState: state.myState,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(artifactActions, dispatch),
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ArtifactViewReferencesListItem);
